<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-22 10:31:15
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-27 10:07:54
 * @Description: description
-->
<template>
  <div class="detail-header">
    <div class="detail-header-title">
      <i :class="['iconfont', icon]" :style="iconStyle"></i>
      <span class="subpage-head-text">{{ title }}</span>
      <el-tooltip
        v-if="tip"
        :content="tip"
        placement="right"
        popper-class="toolTipStyle"
      >
        <i class="icon-tishi iconfont .tips-icon-list"></i>
      </el-tooltip>
    </div>
    <common-button
      style="float: right"
      size="default"
      type="cancel"
      image
      @click="back"
      >返回</common-button
    >
  </div>
</template>

<script>
export default {
  name: "DetailHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    tip: {
      type: String,
      default: ""
    },
    iconStyle: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    back() {
      this.$emit("back");
    }
  }
};
</script>
<style lang="scss" scoped>
.detail-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 10px;
  line-height: 20px;
  &-title {
    display: flex;
    align-items: center;
  }
  .subpage-head-text {
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 22px;
    padding: 0 5px 0 10px;
    color: rgb(8, 39, 44);
  }
  .icon-fenxiang {
    color: #29c4e4;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/DetailHeader.vue